import { EmptyState as EmptyStateUi } from 'ui/emptyState';
import { NoResult } from 'ui/illustrations';
import { EmptyStateWrapper } from './SimpleTable.styled';

type Props = {
  pluralResourceName: string;
};

export const EmptyState = ({ pluralResourceName }: Props) => {
  const title = `You'll find your ${pluralResourceName} here`;
  return (
    <EmptyStateWrapper data-test="simple-table-empty-state">
      <EmptyStateUi
        title={title}
        subtitle=""
        Illustration={() => <NoResult width={150} height={150} />}
      />
    </EmptyStateWrapper>
  );
};
